import React from 'react';
import FundingCopyableField from './FundingCopyableField';
import { maskEin } from '../../../utils/fundingClientIntakeUtils';

const SecureEinCell = ({ value, className = '', stopPropagation = true, testId = 'secure-ein-field' }) => {
  if (!value) {
    return <span className="text-[var(--fg-muted)]">—</span>;
  }

  const raw = String(value);
  const looksMasked = raw.includes('*');
  const einInfo = looksMasked ? { masked: raw, full: '' } : maskEin(raw);
  const maskedValue = einInfo.masked || '**-*******';

  return (
    <FundingCopyableField
      inline
      maskedValue={maskedValue}
      value={looksMasked ? '' : raw}
      isSensitive
      canReveal={Boolean(einInfo.full || (!looksMasked && raw))}
      onReveal={async () => (looksMasked ? null : raw)}
      copyValue={looksMasked ? undefined : raw}
      copyRequiresReveal={looksMasked}
      className={`rounded-lg bg-[var(--fg-panel-soft)] px-2 py-1 font-mono text-sm ${className}`}
      stopPropagation={stopPropagation}
      monospace
      testId={testId}
    />
  );
};

export default SecureEinCell;
